import { gql } from '@apollo/client';
import KEYBOARDING_CURRICULUM_ACTIVITY_FRAGMENT from 'graph/fragments/keyboarding-curriculum-activity';

const GET_KEYBOARDING_CURRICULUMS = gql`
  query KeyboardingCurriculums($where: KeyboardingCurriculumsWhereInput) {
    keyboardingCurriculums(where: $where) {
      id
      name
      curriculumActivities {
        ...BaseKeyboadingCurriculumActivity
      }
    }
  }
  ${KEYBOARDING_CURRICULUM_ACTIVITY_FRAGMENT}
`;

export default GET_KEYBOARDING_CURRICULUMS;
